import { Button, Text, useNetworkState } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { routes } from '~/client/config/routes';
import { useClientPinAuthInfo } from '~/client/hooks/authHooks';
import { useCurrentUser } from '~/client/hooks/storeHooks';
import { signIn } from '~/client/lib/auth';
import { useAppStore } from '~/client/store/app/appStore';

import { ResetPin, UserPinAuth } from '../../shared/UserPinAuth';
import { SplashPage } from '../SplashPage';
import { AppUnavailable } from './AppUnavailable';

export const LoginWithPinPage: FunctionComponent = () => {
  const { online } = useNetworkState();

  const navigate = useNavigate();

  const currentUser = useCurrentUser();
  const loginRedirectUri = useAppStore((state) => state.loginRedirectUri);
  const setLoginRedirectUri = useAppStore((state) => state.setLoginRedirectUri);

  const [hasUnexpectedError, setHasUnexpectedError] = useState(false);

  const { username } = useClientPinAuthInfo();

  const heading = username ? 'Welcome back!' : 'Welcome!';
  const message = username
    ? 'Please sign in by entering your PIN.'
    : 'Please sign in using your Camden account.';

  const handleSignIn = () => signIn(loginRedirectUri);

  useEffect(() => {
    if (currentUser) {
      void navigate(loginRedirectUri || routes.home, { replace: true });
      setLoginRedirectUri(undefined);
    }
  }, [currentUser]);

  useEffect(() => {
    if (hasUnexpectedError) {
      handleSignIn();
    }
  }, [hasUnexpectedError]);

  const footerContent = username && online && (
    <>
      <ResetPin />
      <Text variant="body2" $color="textSecondary">{`Not ${username}?`}</Text>
      <Button $variant="tertiary" $color="primary" onClick={handleSignIn}>
        Sign in as another user
      </Button>
    </>
  );

  return (
    <SplashPage footerContent={footerContent}>
      {online ? (
        <>
          <Text variant="h1">{heading}</Text>
          <Text variant="lead">{message}</Text>

          {username && <UserPinAuth onUnexpectedError={() => setHasUnexpectedError(true)} />}

          {!username && <Button onClick={handleSignIn}>Sign in</Button>}
        </>
      ) : (
        <AppUnavailable />
      )}
    </SplashPage>
  );
};
